import React, { useEffect, useState, Fragment } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import Wrapper from '../../components/Wrapper/Wrapper';
import { tripTableHeight, tableHeightWithSparkline } from "../../../styleVariables";
import { DataGrid } from '@material-ui/data-grid';
import { connect } from "react-redux";
import { logoutUser } from "../../../store/actions/authActionCreators";
import MUIDataTable from "mui-datatables";
import { getTripLedgerData, getTripLedgerDataV2 } from "../../../store/actions/homeActionCreator";
import * as logger from "../../../logger";
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { numberFormat, getDatePickerDateInStringDDMMMYYYY } from '../../../utils/utils'
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import useStyles from '../css/listing'
import ActionIconButton from '../../components/Actions/ActionIconButton';
import EditIcon from '@material-ui/icons/Edit';
import ColumnActions from '../../components/Actions/ColumnActions';
import VisibilityIcon from '@material-ui/icons/Visibility';
import {
  TRIP_ACTIONS,
  TRIP_STATUS_DIALOG_TITLES,
  TRIP_STATUS_DIALOG_LABELS,
  TRIP_FILTER_STATUS,
  TRIP_FILTER_STATUS_MAPPING,
  PAYMENT_CHIPS,
  TRIP_STATUS_LABELS
} from "../../../store/constants";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import TopCard from '../../components/TopCard/TopCard';
import { trackDwebEvent } from '../../analytics';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import CustomDateFilterDialog from '../../components/FilterComponent/CustomDateFilter';
import DateFilter from '../../components/FilterComponent/DateFilter';
import TripStatusFilter from '../../components/FilterComponent/TripStatusFIlter';
import { getTripStartDateFilterValues } from '../../../utils/utils';
import { Waypoint } from "react-waypoint";
import { defaultPageNo, defaultPageSize, defaultDebounceMs } from '../../../paginationVariables';
import { debounce } from 'lodash';
import moment from 'moment';

const Trips = ({ user, dispatchGetTripLedgerAction, router }) => {
  const classes = useStyles();
  let history = useHistory();
  const [tripLedgerData, setTripLedgerData] = useState([]);
  const [addPartyModalOpen, setPartyModalOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedFilterStatus, setSelectedFilterStatus] = useState("ACTIVE");
  const [selectedFilterDate, setSelectedFilterDate] = useState("ALL_MONTHS");
  const [changeFlag, setChangeFlag] = useState(false);
  const [customFilter, setCustomFilter] = useState(false);
  const [customFilterValue, setCustomFilterValue] = useState({});
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(10);
  const [loadingText, setLoadingText] = useState("Sorry, no Trips found");

  let dateFilterValues = getTripStartDateFilterValues();
  const getDateRangeValue = () => {
    let date = `${moment(dateFilterValues[selectedFilterDate]["startDateRange"]["startTimeEpoch"] * 1000).format('YYYY-MM-DD')},${moment(dateFilterValues[selectedFilterDate]["startDateRange"]["endTimeEpoch"] * 1000).format('YYYY-MM-DD')}`;
    if (customFilterValue && customFilterValue.startTimeEpoch) {
      date = `${moment(customFilterValue["startTimeEpoch"] * 1000).format('YYYY-MM-DD')},${moment(customFilterValue["endTimeEpoch"] * 1000).format('YYYY-MM-DD')}`;
    }
    return [date]
  }
  const tripLedgerRequestData = {
    fleetOwnerId: user.userInfo.entityId,
    search: searchText,
    filters: [
      {
        "filterKey": "tripStatus",
        "values": TRIP_FILTER_STATUS_MAPPING[selectedFilterStatus]
      },
      {
        "filterKey": "startDate",
        "values": getDateRangeValue()
      }
    ],
    pageNo: currentPageNo,
    pageSize: currentPageSize,
    //status: TRIP_FILTER_STATUS_MAPPING[selectedFilterStatus],
    startDateRange: dateFilterValues[selectedFilterDate]["startDateRange"]
  };

  useEffect(() => {
    dispatchGetTripLedgerAction({ ...tripLedgerRequestData },
      () => {
        trackDwebEvent('Dweb Trips Page', {});
        logger.log("Trip Ledger", "Trip Ledger Data Loading Success");
      },
      () => {
        logger.log("Trip Ledger", "Trip Ledger Data Loading Failure");
      }
    )
  }, [
    dispatchGetTripLedgerAction
  ]);

  // useEffect(() => {

  //   dispatchGetTripLedgerAction({
  //     ...tripLedgerRequestData
  //   })
  // }, []);

  useEffect(() => {
    if (user.tripLedgerDataV2) {
      setTripLedgerData(user.tripLedgerDataV2);
    }
  }, [user.tripLedgerDataV2]);

  const onSearchBlur = debounce(query => {
    setCurrentPageNo(defaultPageNo)
    tripLedgerRequestData.pageNo = 1;
    dispatchGetTripLedgerAction({ ...tripLedgerRequestData, search: query },
      () => {
        trackDwebEvent('Dweb Trips Page', {});
        logger.log("Trip Ledger", "Trip Ledger Data Loading Success");
        setLoadingText("Sorry, no Trips found");
      },
      () => {
        logger.log("Trip Ledger", "Trip Ledger Data Loading Failure");
        setLoadingText("Sorry, no Trips found");
      }
    )
  }, user && user.configs && user.configs.dwebSearchBebounceMs ? parseInt(user.configs.dwebSearchBebounceMs) : defaultDebounceMs);

  const getPaginatedData = () => {

    const tripLedgerRequestData = {
      merge: true,
      fleetOwnerId: user.userInfo.entityId,
      pageNo: currentPageNo + 1,
      pageSize: currentPageSize,
      search: searchText,
      filters: [
        {
          "filterKey": "tripStatus",
          "values": TRIP_FILTER_STATUS_MAPPING[selectedFilterStatus]
        },
        {
          "filterKey": "startDate",
          "values": getDateRangeValue()
        }
      ],
      //status: TRIP_FILTER_STATUS_MAPPING[selectedFilterStatus],
      startDateRange: dateFilterValues[selectedFilterDate]["startDateRange"]
    };

    if (customFilterValue && customFilterValue.startTimeEpoch) {
      tripLedgerRequestData.startDateRange = customFilterValue
    }

    dispatchGetTripLedgerAction({ ...tripLedgerRequestData },
      () => {
        trackDwebEvent('Dweb Trips Page', {});
        logger.log("Trip Ledger", "Trip Ledger Data Loading Success");
      },
      () => {
        logger.log("Trip Ledger", "Trip Ledger Data Loading Failure");
      }
    )

  }

  useEffect(() => {
    setCurrentPageNo(1);
    setTripLedgerData({});
    setLoadingText("Loading........");
    if (changeFlag) {
      const tripLedgerRequestData = {
        fleetOwnerId: user.userInfo.entityId,
        pageNo: defaultPageNo,
        pageSize: defaultPageSize,
        search: searchText,
        filters: [
          {
            "filterKey": "tripStatus",
            "values": TRIP_FILTER_STATUS_MAPPING[selectedFilterStatus]
          },
          {
            "filterKey": "startDate",
            "values": getDateRangeValue()
          }
        ],
        //status: TRIP_FILTER_STATUS_MAPPING[selectedFilterStatus],
        startDateRange: dateFilterValues[selectedFilterDate]["startDateRange"]
      };

      if (customFilterValue && customFilterValue.startTimeEpoch) {
        tripLedgerRequestData.startDateRange = customFilterValue
      }

      dispatchGetTripLedgerAction({ ...tripLedgerRequestData },
        () => {
          trackDwebEvent('Dweb Trips Page', {});
          logger.log("Trip Ledger", "Trip Ledger Data Loading Success");
          setLoadingText("Sorry, no Trips found");
        },
        () => {
          logger.log("Trip Ledger", "Trip Ledger Data Loading Failure");
        }
      )

    }
  }, [selectedFilterStatus, selectedFilterDate, customFilterValue]);

  const columns = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'firstName', headerName: 'First name', width: 130 },
    { field: 'lastName', headerName: 'Last name', width: 130 },
    {
      field: 'age',
      headerName: 'Age',
      type: 'number',
      width: 90,
    },
    {
      field: 'fullName',
      headerName: 'Full name',
      description: 'This column has a value getter and is not sortable.',
      sortable: false,
      width: 160,
      valueGetter: (params) =>
        `${params.getValue('firstName') || ''} ${params.getValue('lastName') || ''}`,
    },
  ];

  const goToCreateTrip = (id) => {
    history.push({
      pathname: '/trips/create',
      state: {
        id: 7,
        pageTitle: 'Create Trip'
      }
    })
  }

  const goToTripView = (data) => {
    if (data && data.journeyId) {
      history.push({
        pathname: `/trips/view/${data.journeyId}`,
        state: {
          id: 7,
          tripData: data,
          tripView: true,
          pageTitle: 'Trip Details',
          // pageSubTitle: data && data.vehicleNumber ? data.vehicleNumber : ''
        }
      });
    }
  }

  const handleAddPartyClick = () => {
    setPartyModalOpen(true);
  }

  const handleAddPartyModalClose = (status) => {
    setPartyModalOpen(status);
  }

  const handlePartySave = (status) => {
    if (status) {
      dispatchGetTripLedgerAction(tripLedgerRequestData, () => {
      }, () => {
      })
    }
  }

  const handleDateValue = (value) => {
    if (value == "CUSTOM") {
      setCustomFilter(true);
    }
    else {
      setSelectedFilterDate(value);
      setCustomFilter(false);
      setCustomFilterValue({});
    }
    setChangeFlag(true);
  }

  const handleCustomFilterClose = () => {
    setCustomFilter(false);
  }

  const handleCustomFilterConfirm = (value) => {
    setSelectedFilterDate("CUSTOM");
    setCustomFilter(false);
    setCustomFilterValue(value);
  }

  const handleTripStatusValue = (value) => {
    setSelectedFilterStatus(value);
    setChangeFlag(true);
  }
  const muiData = tripLedgerData && tripLedgerData.tripLedgerData ? tripLedgerData.tripLedgerData : [];

  const muiColumns = [
    /*{
      name: "slNo",
      label: "Sl No",
      options: {
        filter: false,
        sort: false,
        searchable:false,
        viewColumns:true,
        customBodyRenderLite: (dataIndex,rowIndex) => {
          return rowIndex+1;
        }
      },
    },*/
    /*{
      name: "actions",
      label: "Actions",
      options: {
        filter: false,
        sort: false,
        empty:false,
        download:false,
        searchable:false,
        viewColumns:false,
        customBodyRenderLite: (dataIndex,rowIndex) => {
          return (<ColumnActions>
            <ActionIconButton size="small" onClick={()=>goToTripView(muiData[dataIndex])}>
              <VisibilityIcon />
            </ActionIconButton>
          </ColumnActions>);
        }
      },
    },*/
    {
      name: "startDate",
      label: "Start Date",
      options: {
        filter: true,
        sort: true,
        sortThirdClickReset: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const rowIndex = tableMeta.rowIndex;

          if (rowIndex === muiData.length - 1) {
            return (
              <Fragment>
                <Waypoint
                  onEnter={() => {
                    if (tripLedgerData && !tripLedgerData.endOfDataFetch && (muiData.length != tripLedgerData.totalCount)) {
                      setCurrentPageNo((prevState) => prevState + 1);
                      getPaginatedData();
                    }
                  }}
                />
                {value}
              </Fragment>
            );
          } else {
            return <Fragment>{value}</Fragment>;
          }
        }
      },
    },
    {
      name: "lrNumber",
      label: "LR Number",
      options: {
        customBodyRender: (value) => {
          return (
            <div>
              {value ? value : ""}
            </div>
          )
        }
      }
    },
    {
      name: "customerName",
      label: "Party Name",
      options: {
        filter: true,
        sort: true,
        sortThirdClickReset: true,
      },
    },
    {
      name: "vehicleNumber",
      label: "Truck No",
      options: {
        filter: true,
        sort: true,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            <>
              <div style={{ display: 'flex', textTransform: 'uppercase' }}>
                {tripLedgerData.tripLedgerData && tripLedgerData.tripLedgerData[dataIndex] && tripLedgerData.tripLedgerData[dataIndex].vehicleNumArrayDweb && tripLedgerData.tripLedgerData[dataIndex].vehicleNumArrayDweb && tripLedgerData.tripLedgerData[dataIndex].vehicleNumArrayDweb.map((item) => (
                  <>
                    <div className={classes.vehileNumber}>{item}</div>

                  </>
                ))
                }
                <div>
                  {tripLedgerData.tripLedgerData[dataIndex].vehicle.ownershipType == "SELF" &&
                    <div className={classes.ownTruck}>OWN</div>
                  }
                  {tripLedgerData.tripLedgerData[dataIndex].vehicle.ownershipType == "HIRED" &&
                    <div className={classes.marketTruck}>MARKET</div>
                  }
                </div>
              </div>
            </>
          )
        },
        sortThirdClickReset: true,
      },
    }, {
      name: "startDest",
      label: "Route",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            (
              (muiData[dataIndex].startLocation && muiData[dataIndex].destinationLocation)
                ?
                < div className={classes.divLocation} > <div>{muiData[dataIndex].startLocation}</div><ArrowRightAltIcon className={classes.arrowRightV1} /><div>{muiData[dataIndex].destinationLocation}</div></div >
                :
                <div className={classes.fw300}>N/A</div>
            )
          )
        }
      },
    },
    /*{
      name: "freightAmount",
      label: "Freight",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
            return <span>{numberFormat(Number(value))}</span>
        }
      },
    },*/
    {
      name: "status",
      label: "Trip Status",
      options: {
        filter: true,
        sort: true,
        sortThirdClickReset: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div className={classes.statusDiv}> <FiberManualRecordIcon
              className={classes[value + '_BULLET']}
            ></FiberManualRecordIcon><div className={classes[value]}>{TRIP_STATUS_LABELS[value]}</div></div>
          )
        }
      },
    },
    {
      name: "amount",
      label: "Party Balance",
      options: {
        filter: true,
        sort: true,
        sortThirdClickReset: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span className={classes.balance}>{numberFormat(Number(value))}</span>
        }
      },
    }
  ];

  const options = {
    rowsPerPage: 100,
    rowsPerPageOptions: [10, 100, 250],
    filterType: "multiselect",
    tableBodyHeight: tripTableHeight,
    selectableRows: 'none',
    searchOpen: true,
    search: false,
    sort: false,
    jumpToPage: false,
    download: false,
    filter: false,
    print: false,
    pagination: false,
    viewColumns: false,
    sortOrder: {
      name: 'startDateTable',
      direction: 'desc'
    },
    onRowClick: (rowData, rowMeta) => {
      goToTripView(muiData[rowMeta.dataIndex])
    },
    customToolbar: (data) => {
      return <>
        {/* <Button variant="contained" classes={{ root: classes.addTripCta, label: classes.label, }} color="primary"
          onClick={goToCreateTrip}>
          <AddIcon /> Add Trip
        </Button> */}
        <div className={classes.divTripListing}>
          <div className={classes.mtV2TripListing}>
            <span>
              <div className={classes.divDateTripListing}>Date</div>
              <DateFilter fromTripListing={true} dateValue={handleDateValue} />
            </span>
            <span className={classes.mlV2}>
              <div className={classes.divTripStatusTripListing}>Trip Status</div>
              <TripStatusFilter fromTripListing={true} status={handleTripStatusValue} defaultTripStatusFilter={selectedFilterStatus} />
            </span>
          </div>
        </div>
      </>
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {

    },
    searchProps: {
      // value: searchText,
      variant: "outlined",
      InputProps: {
        startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
      },
      onBlur: (e) => {
      },
      onKeyUp: (e) => {
      },
      onKeyDown: (event) => {
        if (event.keyCode === 27) {
        }
      }
    },
    searchPlaceholder: 'Search Trips',
    onSearchChange: (val) => {
      let value = val ? !val.replace(/\s/g, '').length ? val.trim() : val : "";
      setSearchText(value);
      if (value && value.length > 1) {
        onSearchBlur(value);
        setTripLedgerData({});
        setLoadingText("Loading........");
      } else if (searchText && value && value.trim().length <= 1) {
        setSearchText("");
        onSearchBlur("");
      }else{
        setSearchText("");
        onSearchBlur("");
      }
    },
    onSearchClose: () => {
    },
    customSearch: (searchQuery, currentRow, columns) => {
      let isFound = true;
      /*if (searchQuery && searchQuery.trim().length > 0) {
        searchQuery = searchQuery.trim()
        currentRow.forEach((col, index) => {
          if (index == 0) {
            col = getDatePickerDateInStringDDMMMYYYY(new Date(Number(col) * 1000));
          }
          if (col && col.toString().toLowerCase().indexOf(searchQuery.toLowerCase()) >= 0) {
            isFound = true;
          }
        });
      } else {
        isFound = true;
      }*/
      return isFound;
    },
    textLabels: {
      body: {
        noMatch: loadingText,
        toolTip: "Sort",
        columnHeaderTooltip: column => `Sort for ${column.label}`
      }
    }
  };

  return (<Wrapper>
    <Paper className={classes.pageContentDIvTrip} elevation={3}>
      {/* <Grid container justify="flex-start" spacing={3}  direction="row" alignItems="center">
            <Grid item>
              <TopCard title='Total Party Balance' infoTitle='Total Party Balance' infoText='The total balance amount to be collected from all your parties'
              color="#de1c22" infoIcon={true} cardValue={numberFormat(user.partyBalance?user.partyBalance:0)} />
            </Grid>
            <Grid item>
              <TopCard title='Total Active Trips' infoTitle='Total Active Trips' infoText='The total number of trips with a balance amount from party' color="#00875a" infoIcon={true} cardValue={user.activeTripCount?user.activeTripCount:0} />
            </Grid>
        </Grid> */}
      <div className={classes.tripTable}>
        <MUIDataTable title={""} data={muiData} columns={muiColumns} options={options} />
      </div>
    </Paper>

    {customFilter && <CustomDateFilterDialog open={customFilter} onClose={handleCustomFilterClose} onConfirm={handleCustomFilterConfirm} />}

  </Wrapper>);
};
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchLogoutAction: () => dispatch(logoutUser()),
  dispatchGetTripLedgerAction: (requestData, onSuccess, onError) => {
    dispatch(getTripLedgerDataV2(requestData, onSuccess, onError))
  }
});
const TripsWithRouter = withRouter(Trips);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripsWithRouter);
